import React from 'react';

const Button = ({ children, variant = 'primary', className = '' }) => {
    const baseStyle = "px-6 py-2 rounded-full font-medium transition-all duration-300 transform hover:scale-105";
    const variants = {
        primary: "bg-sand-beige text-petrol hover:bg-brick hover:text-pastel-yellow shadow-lg shadow-sand-beige/20 transition-all duration-300 hover:scale-105",
        red: "bg-brick text-pastel-yellow hover:bg-sand-beige hover:text-petrol shadow-lg shadow-brick/20",
        outline: "border border-white/20 text-white hover:bg-white/10 backdrop-blur-sm"
    };

    return (
        <button className={`${baseStyle} ${variants[variant]} ${className}`}>
            {children}
        </button>
    );
};

export default Button;
